import React, { useState, useRef, useEffect } from 'react'; // Import useEffect
import { glyphPaths } from '../icons/icon-paths.js'; // Use the generated JS paths

const iconIds = [
    'g01', 'g02', 'g03', 'g04', 'g05',
    'g06', 'g07', 'g08', 'g09', 'g10', 'g11'
];

const GlyphSvg = ({ glyph, color, size, onClick, ...restProps }) => { // Added onClick prop
    const [currentDisplayedGlyph, setCurrentDisplayedGlyph] = useState(glyph);
    const intervalRef = useRef(null);

    // --- NEW: Synchronize internal state with 'glyph' prop changes ---
    useEffect(() => {
        // 1. Stop any ongoing animation
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
        // 2. Reset the displayed glyph to the new prop value
        setCurrentDisplayedGlyph(glyph);
    }, [glyph]); // This effect runs whenever the 'glyph' prop changes

    // Animation logic (remains mostly the same)
    const animateGlyph = () => {
        if (intervalRef.current) {
            return; // Animation already running
        }

        let startIndex = iconIds.indexOf(glyph);
        if (startIndex === -1) {
            startIndex = 0;
        }

        let animationStepCounter = 0;
        const totalAnimationSteps = 5;
        let currentCycleIndex = startIndex;

        intervalRef.current = setInterval(() => {
            if (animationStepCounter >= totalAnimationSteps) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
                return;
            }
            currentCycleIndex = (currentCycleIndex + 1) % iconIds.length;
            const nextGlyph = iconIds[currentCycleIndex];
            setCurrentDisplayedGlyph(nextGlyph);
            animationStepCounter++;
        }, 50);
    };

    const stopAnimation = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
        setCurrentDisplayedGlyph(glyph); // Revert to the original prop value
    };

    const glyphMarkup = { __html: glyphPaths[currentDisplayedGlyph] || '' };

    return (
        <svg
            viewBox="0 0 24 24"
            style={{ position: 'relative', top: '-2px' }}
            className="svg-glyph"
            fill={color}
            width={size}
            height={size}
            onMouseEnter={animateGlyph}
            onMouseLeave={stopAnimation}
            onClick={onClick} // Pass through the onClick prop to the SVG element
            role="img"
            aria-label={`Interactive icon, currently ${currentDisplayedGlyph}`}
            dangerouslySetInnerHTML={glyphMarkup}
            {...restProps} // Pass any other props down if you have them
        >
        </svg>
    );
};

GlyphSvg.defaultProps = {
    size: 24,
    color: 'black',
    glyph: 'g01',
};

export default GlyphSvg;

// OLD SIMPLE GLYPH CODE

// import React from 'react';
// import Glyphs from '../icons/itora-glyphs.svg';

// const GlyphSvg = ({glyph, color, size}) => (
//    <svg className="svg-gylph" fill={color} width={size} height={size}>
//        <use href={`${Glyphs}#${glyph}`} />
//    </svg>
// );

// GlyphSvg.defaultProps = {
//    size: 24,
//    color: 'black',
// };

// export default GlyphSvg;